export default "__VITE_ASSET__8c7b52da__"